import React, { useContext, useState } from 'react';
import { ActionModal } from '../../../../components/Modal';
import { TextInput } from '../../../../components/TextInput';
import { Button, ButtonVariant } from '../../../../components/Button';
import { useToast } from '../../../../../providers/ToastProvider';
import { ToastType } from '../../../../components/Toast';
import { useMutation } from '@apollo/client';
import { Elteros } from '../../../../../types/customer/Elteros/Elteros';
import { ProductTransactionContext } from '../../../../../context/ProductTransactionContext';
import { ProductTransaction } from '../../../../../types/productTransaction';

interface StockReservationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function StockReservationModal({ open, setOpen }: StockReservationModalProps) {
  const { showToast } = useToast();

  const { productTransactions, setProductTransactions } = useContext(ProductTransactionContext);

  const [salesOrder, setSalesOrder] = useState<string>('');

  const [reserveStock, { loading }] = useMutation<Elteros.StockReservationResponse, Elteros.StockReservationVariables>(
    Elteros.stockReservation,
    {
      onCompleted: res => {
        const transactions = res.stockReservation;
        transactions.forEach(transaction =>
          productTransactions.set(transaction.id, new ProductTransaction(transaction)),
        );
        setProductTransactions(new Map(productTransactions));

        showToast({
          type: ToastType.success,
          title: `Stock reserved for Sales Order ${salesOrder}. Moved ${transactions.length} items to reserved stock.`,
        });
        setOpen(false);
      },
      onError: err => {
        showToast({
          type: ToastType.error,
          title: err.message,
        });
      },
    },
  );

  const handleReservation = async () => {
    await reserveStock({ variables: { salesOrder } });
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <Button disabled={loading} variant={ButtonVariant.secondary} text={'Cancel'} onClick={() => setOpen(false)} />
      <Button loading={loading} text={'Reserve'} onClick={handleReservation} />
    </div>
  );

  return (
    <ActionModal footer={footer} title={'Stock Reservation'} open={open} setOpen={setOpen} className='max-w-[720px]'>
      <div>
        <TextInput
          mandatory
          value={salesOrder}
          onChange={v => setSalesOrder(v)}
          label={'Sales Order No.'}
          placeholder={'Sales Order No.'}
        />
      </div>
    </ActionModal>
  );
}
